export interface SelectableCurrency {
  code: string;
  name: string;
  is_active?: boolean;
}

const CURRENCY_NAMES: Record<string, string> = {
  PKR: 'Pakistani Rupee',
};

export const getCurrencyOptions = (
  currencies: SelectableCurrency[],
  requiredCodes: Array<string | null | undefined>
): SelectableCurrency[] => {
  const options = currencies
    .filter((currency) => currency.is_active !== false)
    .map((currency) => ({ ...currency }));

  const required = [...new Set(
    requiredCodes
      .map((code) => code?.trim().toUpperCase())
      .filter((code): code is string => Boolean(code))
  )];

  required.forEach((code) => {
    if (options.some((currency) => currency.code.toUpperCase() === code)) return;

    const existing = currencies.find((currency) => currency.code.toUpperCase() === code);
    options.push(existing
      ? { ...existing, is_active: true }
      : {
          code,
          name: CURRENCY_NAMES[code] || code,
          is_active: true,
        });
  });

  return options.sort((left, right) => left.code.localeCompare(right.code));
};
